export const yearsOptions = [
  {'key': '2', 'value': 2020, 'text': '2020'},
  {'key': '3', 'value': 2021, 'text': '2021'},
  {'key': '4', 'value': 2022, 'text': '2022'},
  {'key': '5', 'value': 2023, 'text': '2023'},
  {'key': '6', 'value': 2024, 'text': '2024'},
  {'key': '7', 'value': 2025, 'text': '2025'},
  {'key': '8', 'value': 2026, 'text': '2026'},
  {'key': '9', 'value': 2027, 'text': '2027'},
  {'key': '10', 'value': 2028, 'text': '2028'},
  {'key': '11', 'value': 2029, 'text': '2029'},
  {'key': '12', 'value': 2030, 'text': '2030'},
];
